import Swal from 'sweetalert2';
import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getEstimateNumber(cookies, plantId, estimateDate) {
    const dateParam = encodeURIComponent(estimateDate || '');
    const url = `${apiBaseUrl}/concrete_estimators/estimate_number/?plant_id=${plantId}&estimate_date=${dateParam}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getConcreteEstimatorList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getConcreteEstimatorDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${id}/`).then((r) => r.data);
}

export function createConcreteEstimator(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/concrete_estimators/`, payload).then((r) => r.data);
}

export function updateConcreteEstimator(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/concrete_estimators/${id}/`, payload).then((r) => r.data);
}

export function deleteConcreteEstimator(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/concrete_estimators/${id}/`).then((r) => r.data);
}

export function printConcreteEstimator(cookies, id, reportType = 'quantity') {
    const query = new URLSearchParams({ report_type: reportType || 'quantity' }).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${id}/print_estimate/?${query}`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export const CONCRETE_ESTIMATE_PDF_OPTIONS = {
    quantity: 'Concrete Quantity Estimate',
    rate: 'Concrete Rate Estimate',
    quantity_rate: 'Concrete Quantity with Rate Estimate',
};

export async function chooseConcreteEstimatePdfType(defaultType = 'quantity_rate') {
    const result = await Swal.fire({
        title: 'Generate PDF',
        text: 'Select the estimate report to print',
        input: 'radio',
        inputOptions: CONCRETE_ESTIMATE_PDF_OPTIONS,
        inputValue: defaultType,
        showCancelButton: true,
        confirmButtonText: 'Generate PDF',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => {
            if (!value) return 'Please select a report type';
            return undefined;
        },
    });
    if (!result.isConfirmed || !result.value) return null;
    return result.value;
}

export async function getFinishedGoodsGrades(cookies) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/finished_goods_grades/`)
        .then((r) => r.data);
}

export async function getDesignMixOptions(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/design_mix_options/?${query.toString()}`)
        .then((r) => r.data);
}

export async function applyDesignMixToRateWorking(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/apply_design_mix/?${query.toString()}`)
        .then((r) => r.data);
}

export async function getDieselRate(cookies, plantId) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/diesel_rate/?plant_id=${plantId}`)
        .then((r) => r.data);
}

export async function getRateWorkingPreview(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/rate_working_preview/?${query.toString()}`)
        .then((r) => r.data);
}

export async function getPincodeAreas(cookies, pincode) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/pincode_areas/?pincode=${encodeURIComponent(pincode)}`)
        .then((r) => r.data);
}

export async function getSiteRoute(cookies, payload) {
    return getApiClient(cookies)
        .post(`${apiBaseUrl}/concrete_estimators/site_route/`, payload)
        .then((r) => r.data);
}
